<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: 'feedback',
  data() {
    return {}
  },
}
</script>
